module.exports = __webpack_public_path__ + "media/images/scoreBet__detailScore__markWrong--dark-e798c3ffdf6fe1beafd854e18c99ec2c.png";